import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setSelectedAccountId } from '../../redux/actions';
import { getAccountList } from '../../businessLogic/AccountsBL';
import AccountSelectionComponent from '../../components/AccountSelectionComponent';
import { isCAUser } from '../../infrastructure/config/selectors';

export class AccountSelectionContainer extends Component {
  constructor(props) {
    super(props);
    this.onAccountClick = this.onAccountClick.bind(this);
    this.backClick = this.backClick.bind(this);
  }
  onAccountClick(accounts) {
    const { setSelectedAccountId, routeTo } = this.props;
    setSelectedAccountId(accounts.id);
    routeTo('/singlealerts');
  }

  backClick() {
    this.props.routeTo('/exit');
  }

  render() {
    const { content, accountList, userPhoneNumber, isCAUser } = this.props;
    const {
      alertLandingPageHeader,
      alertLandingPageFooter,
      alertLandingPageInfo,
      accountSelectionHeading,
      poundSign,
      alertSMELandingPageInfo,
    } = content;
    return (
      <AccountSelectionComponent
        onAccountClick={this.onAccountClick}
        alertLandingPageFooter={alertLandingPageFooter}
        alertLandingPageHeader={alertLandingPageHeader}
        alertLandingPageInfo={alertLandingPageInfo}
        poundSign={poundSign}
        validAccountList={getAccountList(accountList.accounts)}
        userPhoneNumber={userPhoneNumber}
        backClick={this.backClick}
        accountSelectionHeading={accountSelectionHeading}
        alertSMELandingPageInfo={alertSMELandingPageInfo}
        isCAUser={isCAUser}
      />
    );
  }
}
AccountSelectionContainer.propTypes = {
  accountList: PropTypes.shape({}).isRequired,
  setSelectedAccountId: PropTypes.func,
  masterCardAlertBack: PropTypes.func,
  content: PropTypes.shape({
    alertLandingPageHeader: PropTypes.string,
    alertLandingPageInfo: PropTypes.string,
    alertLandingPageFooter: PropTypes.string,
    accountSelectionHeading: PropTypes.string,
  }),
  accountID: PropTypes.string,
  userPhoneNumber: PropTypes.array,
  routeTo: PropTypes.func,
  isCAUser: PropTypes.bool,
};

const mapStateToProps = ({ accountList, userDetails }) => {
  return {
    accountList: accountList.get('accountList'),
    accountID: accountList.get('selectedAccountId'),
    userPhoneNumber: userDetails.get('userDetails').phone_numbers,
    isCAUser: isCAUser(userDetails),
  };
};
const mapDispatch = (dispatch) => bindActionCreators({ setSelectedAccountId }, dispatch);

export default connect(mapStateToProps, mapDispatch)(AccountSelectionContainer);
